<template>
  <div data-private>
  <PageHeader
    title="Quality"
    subtitle="Track quality measures, medication adherence, and clinical results"
  >
    <template #bottom>
      <Page_Tabs
        :tabs="tabOptions"
        class="px-6 pt-4"
        no-border
      />
    </template>
  </PageHeader>

  <div class="p-6">
    <div class="bg-white rounded border border-gray-200">
      <Quality_Patients_List v-if="activeTab === 'patients'" />
      <MedAdherence_Patients_List v-else-if="activeTab === 'med-adherence'" />
      <Quality_ContractPerformance v-else-if="activeTab === 'stars'" />
      <Quality_ContractTrackers v-else-if="activeTab === 'trackers'" />
      <Quality_Operations v-else-if="activeTab === 'operations'" />
      <Quality_FlatFile v-else-if="activeTab === 'flat-file'" />
      <Quality_ExtractedData v-else-if="activeTab === 'extracted-data'" />
      <Worklist_Assignments
        v-else-if="activeTab === 'assignments'"
        :member-entity-types="['Quality Analyst']"
        member-label="Analyst"
        :fixed-task-type-ids="[14]"
        :hide-programs="true"
        :hide-stages="true"
      />
    </div>
  </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Quality_Patients_List from '@/components/Quality/Quality_Patients_List.vue';
import MedAdherence_Patients_List from '@/components/Quality/MedAdherence_Patients_List.vue';
import Quality_ContractPerformance from '@/components/Quality/Quality_ContractPerformance.vue';
import Quality_ContractTrackers from '@/components/Quality/Quality_ContractTrackers.vue';
import Quality_Operations from '@/components/Quality/Quality_Operations.vue';
import Quality_FlatFile from '@/components/Quality/Quality_FlatFile.vue';
import Quality_ExtractedData from '@/components/Quality/Quality_ExtractedData.vue';
import Worklist_Assignments from '@/components/widgetcomponents/Worklist_Assignments.vue';
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue';
import Page_Tabs from '@/components/widgetcomponents/Page_Tabs.vue';

export default {
  name: 'Quality_Overview',
  components: {
    Quality_Patients_List,
    MedAdherence_Patients_List,
    Quality_ContractPerformance,
    Quality_ContractTrackers,
    Quality_Operations,
    Quality_FlatFile,
    Quality_ExtractedData,
    Worklist_Assignments,
    PageHeader,
    Page_Tabs,
  },
  computed: {
    ...mapGetters('auth', ['current_user']),
    tabOptions() {
      const tabs = [
        { label: 'Quality Patients', icon: ['fas', 'users'], to: '/quality/patients' },
        { label: 'Medication Adherence', icon: ['fas', 'pills'], to: '/quality/medication-adherence' },
        { label: 'Contract Performance', icon: ['fas', 'chart-line'], to: '/quality/stars-performance' },
        { label: 'Trackers', icon: ['fas', 'gauge-high'], to: '/quality/trackers' },
        { label: 'Operations', icon: ['fas', 'list-check'], to: '/quality/operations' },
        { label: 'Flat File', icon: ['fas', 'file-excel'], to: '/quality/flat-file' },
        { label: 'Extracted Data', icon: ['fas', 'notes-medical'], to: '/quality/extracted-data' },
        { label: 'Assignments', icon: ['fas', 'users-cog'], to: '/quality/assignments' },
      ];
      return tabs;
    },
    activeTab() {
      if (this.$route.path.includes('medication-adherence')) return 'med-adherence';
      if (this.$route.path.includes('stars-performance')) return 'stars';
      if (this.$route.path.includes('/quality/trackers')) return 'trackers';
      if (this.$route.path.includes('/quality/operations')) return 'operations';
      if (this.$route.path.includes('flat-file')) return 'flat-file';
      if (this.$route.path.includes('extracted-data')) return 'extracted-data';
      if (this.$route.path.includes('clinical-results') || this.$route.path.includes('ecqm-facts')) return 'extracted-data';
      if (this.$route.path.includes('assignments')) return 'assignments';
      return 'patients';
    },
  },
};
</script>
